<template>
    <div class="wrapper-bg">
        <div class="main-layout coffee">
            <div class="text-center">
                <img
                    class="wrapper_title_logo"
                    src="@/assets/home/logo-new-theme.png"
                />
            </div>
            <div class="welcome-container">
                <div class="title">
                    <span>
                        {{ dashboard.title }}
                    </span>
                </div>
                <div class="detail" v-html="dashboard.detail"></div>
                <button class="btn" @click="gotoSurvey">
                    {{ dashboard.btn }}
                </button>
                <button
                    class="btn"
                    @click="
                        $router.push({
                            name: 'privilege',
                        })
                    "
                >
                    ไม่สนใจ
                </button>
                <div class="bg-coffee"></div>
            </div>
        </div>
    </div>
</template>

<script>
// import Vue from 'vue'
// helper //
import Locale from "@/helper/locale/locale.js";
import Account from "@/helper/AccountHelper.js";
import { SubDashboardConfigBuilder } from "@/core/Campaign/model/DashboardConfigModel.js";
import ConfigManager from "@/config/ConfigManager.js";
import CacheHelper from "@/helper/CacheHelper.js";

// core //
import BzbsDashboard from "@/core/Campaign/service/BzbsDashboard.js";

// mixins
import Mixin from "@/mixin/Mixin";
import ModalMixin from "@/mixin/ModalMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";

export default {
    name: "Welcome",
    components: {},
    mixins: [Mixin, ErrorApiMixin, ModalMixin],
    data: function () {
        return {
            lbl: Locale.getLbl(),
            locale: Locale.getLocaleCode(),
            dashboard: {},
        };
    },
    created() {
        this.handleLoading(true);
        this.getDashboard().then((data) => {
            this.dashboard.title = data.name;
            this.dashboard.detail = data.line1;
            this.dashboard.btn = data.line4;
            this.dashboard.url = data.url.replace(
                "nescafestreet",
                "nescafestreetcafe"
            );
            this.$forceUpdate();
            this.handleLoading(false);
        });
    },
    methods: {
        getDashboard() {
            return new Promise((resolve, reject) => {
                var token = Account.getToken();
                var configBuilder = new SubDashboardConfigBuilder();
                configBuilder.setLocale(Locale.getLocaleCode());

                var params = configBuilder.create().getParams();
                BzbsDashboard.apiGetWelcomeDashboard(
                    token,
                    params,
                    this.apiConfig
                ).subscribe(
                    (data) => {
                        resolve(data[0]);
                    },
                    (err) => {
                        this.errorResponse(err);
                        reject(err);
                    }
                );
            });
        },
        gotoSurvey() {
            var cacheHelper = new CacheHelper(ConfigManager.getCacheType());
            var token = cacheHelper.getCache("BzbsUser").token;
            var shuffleToken =
                token.substring(token.length - 5, token.length) +
                token.substring(1, token.length - 5);
            var url = this.dashboard.url.replace("{token}", shuffleToken);

            window.location = url;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/style/_mixin.scss";
$primary-color: #4d341c;
$secondary-color: rgb(167, 144, 123);
.wrapper-bg {
    padding-bottom: 0;
}
.coffee {
    position: relative;
    min-height: 100vh;
}
.welcome-container {
    color: $color-text;
    padding: 50px 20px 95%;
    text-align: center;
    position: relative;
    .bg-coffee {
        width: 100%;
        height: 0;
        padding-bottom: 94.4%;
        position: absolute;
        bottom: 0;
        left: 50%;
        z-index: 1;
        background: url("../../../assets/survey/bg.png") center no-repeat;
        background-size: cover;
        transform: translate(-50%, 0);
    }
    .title {
        font-family: "PromptSemiBold";
        font-size: 20px;
        &:before {
            content: "";
            width: 20px;
            height: 11px;
            background: url("../../../assets/icon/text-start.svg") center
                no-repeat;
            display: inline-block;
            margin-right: 5px;
            vertical-align: super;
        }
        &:after {
            content: "";
            width: 20px;
            height: 11px;
            background: url("../../../assets/icon/text-end.svg") center
                no-repeat;
            display: inline-block;
            margin-left: 5px;
            vertical-align: bottom;
        }
    }
    .detail {
        font-size: 16px;
        color: $color-text-light;
        padding: 30px 20px 60px;
        white-space: pre-wrap;
    }
    .btn {
        display: block;
        width: 100%;
        background: $primary-color;
        color: #fff;
        font-size: 16px;
        font-family: "PromptSemiBold";
        height: 45px;
        line-height: 44px;
        border-radius: 40px;
        padding: 0;
        + .btn {
            background: none;
            display: inline-block;
            text-decoration: underline;
            color: $color-text;
        }
    }
}
</style>
